var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 57,
    viewBox: "0 0 90 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 76,
    height: 45,
    rx: 5,
    fill: "#2B2726"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0414 56.2949H4.95859C2.2627 56.2949 0.0683594 54.1006 0.0683594 51.4047V5.59531C0.0683594 2.89941 2.2627 0.705078 4.95859 0.705078H85.0414C87.7373 0.705078 89.9316 2.89941 89.9316 5.59531V51.4256C89.9107 54.1006 87.7373 56.2949 85.0414 56.2949ZM4.95859 2.75313C3.39121 2.75313 2.11641 4.02793 2.11641 5.59531V51.4256C2.11641 52.993 3.39121 54.2678 4.95859 54.2678H85.0414C86.6088 54.2678 87.8836 52.993 87.8836 51.4256V5.59531C87.8836 4.02793 86.6088 2.75313 85.0414 2.75313H4.95859Z",
    fill: "#423A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0202 36.3162C43.9544 36.3162 42.8886 35.9609 42.0108 35.2504L34.4665 29.2943L1.78136 3.52657C1.34249 3.1713 1.2589 2.52345 1.61417 2.08458C1.96944 1.64571 2.6173 1.56212 3.05616 1.91739L35.7413 27.6852L43.3065 33.6412C44.3306 34.4563 45.7726 34.4563 46.8175 33.6412L54.3618 27.6852L87.0052 1.91739C87.4441 1.56212 88.0919 1.64571 88.4472 2.08458C88.8025 2.52345 88.7189 3.1713 88.28 3.52657L55.5948 29.2943L48.0505 35.2504C47.1519 35.9818 46.0651 36.3162 45.0202 36.3162Z",
    fill: "#423A38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6331 55.2918C87.4032 55.2918 87.1942 55.2082 87.0062 55.0619L54.3419 29.2941C53.903 28.9389 53.8194 28.291 54.1747 27.8522C54.53 27.4133 55.1778 27.3297 55.6167 27.685L88.3019 53.4527C88.7407 53.808 88.8243 54.4559 88.4691 54.8947C88.2392 55.1455 87.9466 55.2918 87.6331 55.2918Z",
    fill: "#423A38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3673 55.2918C2.07472 55.2918 1.78214 55.1664 1.57316 54.8947C1.21788 54.4559 1.30148 53.808 1.74034 53.4527L34.4046 27.685C34.8435 27.3297 35.4913 27.4133 35.8466 27.8522C36.2019 28.291 36.1183 28.9389 35.6794 29.2941L2.99425 55.0828C2.80616 55.2082 2.59718 55.2918 2.3673 55.2918Z",
    fill: "#423A38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIconDark);
export default __webpack_public_path__ + "static/media/confirm-icon-dark.0973a0f9703035326099fbee7e0c9fb2.svg";
export { ForwardRef as ReactComponent };